/***
 * Created on 2023/8/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
export const GLOBAL = 'GLOBAL';
export const CHINA = 'CHINA';

export const getCurrentDomainRegion = () => {
    if (window.location.hostname?.toLocaleLowerCase().endsWith('cn')) {
        return CHINA
    }
    return GLOBAL;
}

export const getCMSUrl = () => {
    return getCurrentDomainRegion() === GLOBAL ? window.acc_mf.account.CMS_URL : window.acc_mf.account.CMS_URL_CN;
}

export const getCookie = (key) => {
    return document.cookie.split('; ').find(row => row.startsWith(`${key}=`))?.split('=')[1];
}

export const domains = ["@gmail.com" ,"@hotmail.com" ,"@yahoo.com" ,"@gmx.de" ,"@qq.com" ,"@me.com","@web.de","@t-online.de","@mac.com" ,"@live.com" ,"@comcast.net" ,"@googlemail.com" ,"@msn.com","@hotmail.co.uk" ,"@yahoo.co.uk" ,"@facebook.com" ,"@verizon.net","@sbcglobal.net","@att.net","@gmx.net","@outlook.com","@icloud.com","@naver.com","@daum.net","@hanmail.net","@nate.com","@yandex.ru","@mail.ru","@qip.ru","@excite.co.jp","@mail.goo.ne.jp","@goo.jp","@163.com","@126.com","@189.cn","@sina.com","@sina.cn","@aol.com","@aliyun.com","@china.com","@sohu.com","@msa.hinet.net"]
